import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { bookNewbuildingAction } from 'shared/actions/newbuildingBookedFromDeveloper';
import { BookedFromDeveloperConfirmModal } from 'shared/components/BookedFromDeveloperConfirmModal';
import { selectFirstConfirmedPhone } from 'shared/selectors';

import { trackBookingCallbackClick } from './tracking/newbuildingBooking';

export const BookedFromDeveloperConfirmModalContainer = () => {
  const dispatch = useDispatch();
  const userPhone = useSelector(selectFirstConfirmedPhone) || '';
  const initialStatePhone = userPhone.substring(1);
  const [phone, setPhone] = React.useState(initialStatePhone);
  const [term, setTerm] = React.useState(false);
  const [valid, setValid] = React.useState(!!(phone && term));

  const onPhoneChange = React.useCallback(
    (val: string) => {
      setPhone(val);
      setValid(Boolean(term && val));
    },
    [phone, setPhone, setValid, term],
  );

  const onTermChange = React.useCallback(
    (_: React.ChangeEvent<HTMLInputElement>, val: boolean) => {
      setTerm(val);
      setValid(Boolean(phone && val));
    },
    [term, setTerm, setValid, phone],
  );

  const sendData = React.useCallback(() => {
    dispatch(bookNewbuildingAction({ phone }));
    trackBookingCallbackClick();
  }, [phone, bookNewbuildingAction, dispatch]);

  return (
    <BookedFromDeveloperConfirmModal
      onPhoneChange={onPhoneChange}
      phone={phone}
      disabled={!valid}
      onTermChange={onTermChange}
      onSubmit={sendData}
      termsAgreementUrl="https://www.cian.ru/legal-documents/politika_konfidencialnosti_0/"
    />
  );
};
